import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { LayoutComponent } from './layout.component'
import { HeaderComponent } from './header/header.component'
import { RouterModule } from '@angular/router'
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome'
import { SidebarComponent } from './sidebar/sidebar.component'
import { SharedModule } from '../modules/shared/shared.module'
import { DxTooltipModule, DxLoadPanelModule } from 'devextreme-angular'
import { ResetPasswordComponent } from './header/resetPassword/reset-password.component'
import { ModalModule } from 'ngx-bootstrap/modal'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { AuthenticationService } from '../core/authentication/authentication.service'
import { BsDropdownModule } from 'ngx-bootstrap/dropdown'
import { BrowserModule } from '@angular/platform-browser'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'

@NgModule({
  declarations: [LayoutComponent, HeaderComponent, SidebarComponent, ResetPasswordComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    CommonModule,
    RouterModule,
    FontAwesomeModule,
    SharedModule,
    DxTooltipModule,
    ModalModule.forRoot(),
    FormsModule,
    ReactiveFormsModule,
    DxLoadPanelModule,
    BsDropdownModule.forRoot(),
  ],
  exports: [LayoutComponent, HeaderComponent, SidebarComponent],
})
export class LayoutModule {}
